@if (selectedLang !== null && currentLang && i18n.supportedLangs.length > 0) {
  <div class="lang-select" [class.is-open]="isOpen()">
    <button class="lang-select__trigger" (click)="toggle()">
      <img [src]="getFlagUrl(currentLang)" [alt]="currentLang.name" class="lang-select__flag" />
      <span class="lang-select__label">{{ currentLang.name }}</span>
      <i class="pi pi-chevron-down lang-select__chevron"></i>
    </button>

    @if (isOpen()) {
      <ul class="lang-select__dropdown">
        @for (lang of i18n.supportedLangs; track lang.code) {
          <li>
            <button
              class="lang-select__option"
              [class.is-active]="lang.code === selectedLang"
              (click)="selectLang(lang)">
              <img [src]="getFlagUrl(lang)" [alt]="lang.name" class="lang-select__flag" />
              <span>{{ lang.name }}</span>
            </button>
          </li>
        }
      </ul>
    }
  </div>
}
